import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[locale]/(main)/schematics/page.client.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/favicon.ico");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/common/internal-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PaginationFooter","PaginationLayoutSwitcher","GridLayout"] */ "/vercel/path0/components/common/pagination-layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/common/pagination-navigator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/common/tran.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/search/name-tag-search.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.2.4_@opentelemetry+api@1.9.0_babel-plugin-react-compiler@19.0.0-beta-e993439-20250328_xnbi2nfe67rciypvbflggxpbum/node_modules/next/dist/client/image-component.js");
